/**
 * GlobalSearchDialog — the global search box presented as a controllable modal.
 *
 * Reuses the same SearchAutocomplete that powers the header search widget so
 * the search/navigation behaviour stays identical; this only adds external
 * open/onClose control so it can be triggered from e.g. a dashboard quick link.
 * The header instance (GlobalSearch) is untouched.
 */
import { DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ResponsiveDialog } from '@/components/common/ResponsiveDialog';
import { SearchAutocomplete } from './GlobalSearch';

interface GlobalSearchDialogProps {
  open: boolean;
  onClose: () => void;
}

export function GlobalSearchDialog({ open, onClose }: GlobalSearchDialogProps) {
  const { t } = useTranslation('common');

  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      mobileTitle={t('search')}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent sx={{ minHeight: 140, pt: 3 }}>
        <SearchAutocomplete autoFocus onSelect={onClose} />
      </DialogContent>
    </ResponsiveDialog>
  );
}
